// eslint-disable-next-line import/prefer-default-export
export const setType = (theme, type) => ({
  color: theme.typeColor.dark,
  lineHeight: 1.5,
  margin: 0,
  ...{
    body: {
      fontSize: theme.fontSize.body,
      fontWeight: theme.fontWeight.regular,
    },
    bodySm: {
      fontSize: theme.fontSize.bodySm,
      fontWeight: theme.fontWeight.regular,
    },
    cardTitle: {
      fontSize: theme.fontSize.cardTitle,
      fontWeight: theme.fontWeight.medium,
    },
    hero1: {
      fontSize: theme.fontSize.hero1,
      fontWeight: theme.fontWeight.light,
    },
    hero2: {
      fontSize: theme.fontSize.hero2,
      fontWeight: theme.fontWeight.light,
    },
    pageTitle: {
      fontSize: theme.fontSize.pageTitle,
      fontWeight: theme.fontWeight.light,
    },
    sectionTitle: {
      fontSize: theme.fontSize.sectionTitle,
      fontWeight: theme.fontWeight.light,
    },
  }[type],
});
